"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultComboBoxPropertySelector = exports.DefaultCheckboxPropertySelector = exports.DefaultAmountPropertySelector = exports.DefaultTextboxPropertySelector = exports.DefaultAmountFormatSelector = exports.DefaultAmountInputBox = void 0;
const property_1 = require("@genesys/property");
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const AmountFormatSelector = __importStar(require("../amount-format-selector"));
const AmountPropertySelector = __importStar(require("../amount-property-selector"));
const PropertySelectors = __importStar(require("../react-properties-selector"));
const invalid = `
  border-color: red;
  outline: red;
  color: red;
`;
const AmountInputField = (0, styled_components_1.default)(PropertySelectors.AmountInputField) `
  border: 1px solid #617584;
  border-radius: 2px;
  font-size: 12px;
  padding: 2.5px;
  width: 44px;
  ${(props) => (props.isReadonly ? "background-color: #ebebeb;" : "")};
  ${(props) => (props.effectiveErrorMessage ? invalid : "")};
`;
exports.DefaultAmountInputBox = PropertySelectors.createAmountInputBox({
    AmountInputField: AmountInputField
});
exports.DefaultAmountFormatSelector = AmountFormatSelector.createAmountFormatSelector({
    AmountFormatWrapper: (0, styled_components_1.default)(PropertySelectors.AmountFormatWrapper) `
      font-size: 12px;
      padding-left: 5px;
    `,
    CancelButton: styled_components_1.default.button `
      &::after {
        content: "X";
      }
    `,
    ClearButton: styled_components_1.default.button `
      &::after {
        content: "C";
      }
    `
});
const ComboBoxStandardOption = PropertySelectors.createComboBoxStandardOption({
    OptionElement: (0, styled_components_1.default)(PropertySelectors.OptionElement) `
    ${(props) => (!props.isItemValid && "color: red;") || "color: black;"};
  `
});
const DefaultInputTextBox = styled_components_1.default.input `
  border: 1px solid #617584;
  padding: 2px 4px;
  font-size: 12px;
  border-radius: 2px;
  ${(props) => (props.readOnly ? "background-color: #ebebeb;" : "")};
`;
exports.DefaultTextboxPropertySelector = PropertySelectors.createTextboxPropertySelector({
    StyledInputTextBox: DefaultInputTextBox
});
exports.DefaultAmountPropertySelector = AmountPropertySelector.createAmountPropertySelector({
    AmountInputBox: exports.DefaultAmountInputBox,
    AmountFormatSelector: exports.DefaultAmountFormatSelector
});
const DefaultCheckboxContainer = styled_components_1.default.div `
  // This forces the type to match createCheckboxPropertySelector    
  ${(_p) => ""} //

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;

  img {
    max-width: 100px;
    max-height: 100px;
  }
`;
const DefaultCheckbox = (props) => (React.createElement("input", { checked: props.checked, 
    // `onChange` must be set to prevent warning.
    onChange: () => undefined, type: "checkbox" }));
// Copied from `promaster-react`, but does not render the label.
const DefaultCheckboxPropertySelector = (props) => {
    const value = property_1.PropertyValueSet.getValue(props.propertyName, props.propertyValueSet);
    if (!props.valueItems || props.valueItems.length !== 2) {
        return React.createElement("div", null);
    }
    const falseValue = props.valueItems[0];
    const trueValue = props.valueItems[1];
    if (!falseValue.value || !trueValue.value) {
        return React.createElement("div", null);
    }
    const checked = property_1.PropertyValue.equals(trueValue.value, value);
    const nextValue = checked ? falseValue.value : trueValue.value;
    return (React.createElement(DefaultCheckboxContainer, { locked: props.locked, checked: checked, onClick: () => props.onValueChange(nextValue) },
        trueValue.image && React.createElement("img", { src: trueValue.image }),
        React.createElement(DefaultCheckbox, { locked: props.locked, checked: checked })));
};
exports.DefaultCheckboxPropertySelector = DefaultCheckboxPropertySelector;
function comboBoxImageElement(_a) {
    var { isSelectedItemValid: _, locked: _1 } = _a, htmlProps = __rest(_a, ["isSelectedItemValid", "locked"]);
    return React.createElement("div", Object.assign({}, htmlProps), htmlProps.children);
}
function comboBoxImageOptionElementRow(_a) {
    var { isItemValid: _ } = _a, htmlProps = __rest(_a, ["isItemValid"]);
    return React.createElement("div", Object.assign({}, htmlProps), htmlProps.children);
}
const optionImageElementRow = (0, styled_components_1.default)(comboBoxImageOptionElementRow) `
  color: rgb(131, 131, 131);
  min-height: 18px;
  align-self: center;
  border: 0px none rgb(131, 131, 131);
  font: normal normal 300 normal 12px / 30px Helvetica, Arial, sans-serif;
  outline: rgb(131, 131, 131) none 0px;

  padding: 0.2em 0.5em;
  cursor: default;

  &:hover {
    background: rgba(203, 210, 246, 0.79);
    color: white;
  }

  ${(props) => (props.isItemValid === false ? "color: red;" : "")};
`;
const lockedStyle = `
  border: none;
  appearance: none;
  color: #000;
  background: transparent;
  &::-ms-expand {
    display: none;
  }

  &::-ms-value {
    color: #000;
  }
`;
const nonLockedStyle = `
border-radius: 4px;
  border: 1px solid rgb(169, 169, 169);
  background-image: linear-gradient(to top, #e0e0e0, white 60%);
  padding: 2px;

  &::-ms-expand {
    border: none;
    background: transparent;
  }
`;
exports.DefaultComboBoxPropertySelector = PropertySelectors.createComboboxPropertySelector({
    ComboBoxStandardOption: ComboBoxStandardOption,
    ComboBoxStandardSelect: (0, styled_components_1.default)(PropertySelectors.ComboBoxStandardSelect) `
      ${(props) => (props.locked ? lockedStyle : nonLockedStyle)};
      ${(props) => (!props.isSelectedItemValid && invalid) || ""};
      font-size: 12px;
    `,
    ComboBoxImageDropdownSelector: PropertySelectors.createImageDropdownSelector({
        DropdownSelectElement: styled_components_1.default.div `
          display: inline-block;
        `,
        DropdownOptionsElement: styled_components_1.default.div `
          position: absolute;
          display: block;
          background: white;
          border: 1px solid #bbb;
          list-style: none;
          margin: 0;
          padding: 0;
          max-height: 350px;
          overflow-y: scroll;
          z-index: 100;
        `,
        ComboBoxImageButtonElement: (0, styled_components_1.default)(comboBoxImageElement) `
          /* width: 162px; */
          align-items: center;
          background: white;
          color: black;
          white-space: nowrap;
          border: 1px solid #b4b4b4;
          border-radius: 3px;
          font: normal normal 300 normal 12px / 30px Helvetica, Arial,
            sans-serif;
          outline: rgb(131, 131, 131) none 0px;
          padding: 0 10px;

          ${(props) => !props.isSelectedItemValid && "color: red;"}

          i {
            display: none;
          }

          span {
            display: inline-block;
            width: 88%;
          }

          img {
            height: 25px;
            vertical-align: top;
            margin-top: 2px;
            margin-left: 7px;
          }

          &::after {
            content: "▾";
            font-size: 20px;
            line-height: 30px;
            vertical-align: middle;
          }
        `,
        OptionImage: styled_components_1.default.img ``,
        OptionImageElementRow: optionImageElementRow
    })
});
//# sourceMappingURL=index.js.map